import React, {Fragment} from "react";
import ViewHeaderComponent from "./ViewHeaderComponent";
import SFXButtonComponent from "./SFXButtonComponent";
import DropdownComponent from "./DropdownComponent";
import DatePickerComponent from "./DatePickerComponent";
import RegistrationCreationRequest from "../domain/Registration/RegistrationCreationRequest";
import {Col, Input, Row} from "reactstrap";
import RegistrationService from "../services/Registration/RegistrationService";
import ToastHelper from "../utils/ToastHelper";
import UserSessionService from "../services/UserSessionService";
import FileUtil from "../domain/Util/FileUtil";
import RegistrationDocumentsService from "../services/Registration/RegistrationDocumentService";
import S3DocumentUploadComponent from "./S3DocumentUploadComponent";
import LoadingSpinnerComponent from "./LoadingSpinnerComponent";

const PERSONAL_DETAILS = "PERSONAL_DETAILS";
const CONTACT_DETAILS = "CONTACT_DETAILS";
const ADDRESS_DETAILS = "ADDRESS_DETAILS";
const DOCUMENT_DETAILS = "DOCUMENT_DETAILS";
const PERMIT_DETAILS = "PERMIT_DETAILS";

const STEPS = {
    0: PERSONAL_DETAILS,
    1: CONTACT_DETAILS,
    2: ADDRESS_DETAILS,
    3: DOCUMENT_DETAILS,
    4: PERMIT_DETAILS
}

const SA_ID = "SA ID";
const FOREIGN_PASSPORT = "Foreign Passport";
const ASYLUM_PAPER = "Asylum Paper";

const TITLES = [
    {id: "MISS", name: "Miss"},
    {id: "MR", name: "Mr"},
    {id: "MRS", name: "Mrs"},
    {id: "DR", name: "Dr"},
    {id: "PROF", name: "Prof"},
    {id: "REV", name: "Rev"},
    {id: "SIR", name: "Sir"},
    {id: "THE_HONORABLE_MINISTER", name: "The Honourable Minister"},
    {id: "MASTER", name: "Master"},
    {id: "HIS_EMINENCE", name: "His Eminence"},
    {id: "DAME", name: "Dame"},
    {id: "LADY", name: "Lady"},
    {id: "LORD", name: "Lord"},
    {id: "ESTATE_LATE", name: "Estate Late"},
];

const ETHNICITY = [
    {id: "AFRICAN", name: "African"},
    {id: "COLOURED", name: "Coloured"},
    {id: "INDIAN", name: "Indian"},
    {id: "WHITE", name: "White"},
    {id: "OTHER", name: "Other"},
];

const SOURCE_OF_FUNDS = [
    {id: "SALARY", name: "Salary"},
    {id: "DIVIDEND_INTEREST", name: "Dividend/Interest"},
    {id: "COMMISSIONS", name: "Commissions"},
    {id: "BONUSES", name: "Bonuses"},
    {id: "PENSION", name: "Pension"},
    {id: "RENTAL INCOME", name: "Rental Income"},
    {id: "LOAN", name: "Loan"},
    {id: "DONATIONS", name: "Donations"},
    {id: "ALIMONY", name: "Alimony"},
    {id: "CHILD_SUPPORT", name: "Child Support"},
    {id: "UNKNOWN", name: "Unknown"},
    {id: "NONE", name: "None"},
];

const COMPLEX_OPTIONS = [
    {id: 1, name: "Yes"},
    {id: 2, name: "No"}
];

const PERSONAL_DETAILS_CONFIG = ["title", "ethnicity", "sourceOfFunds", "idIssueDate"];
const CONTACT_DETAILS_CONFIG = ["email"];
const ADDRESS_DETAILS_CONFIG = ["streetNumber", "staysInComplex", "complexName", "unit"];
const STAYS_IN_COMPLEX = ["staysInComplex"];

const BUTTON_HEADERS = {
    "Permit": {"buttonHeader": "Photo of the Customer's Permit", "buttonText": "Permit"},
    "Identity": {"buttonHeader": "Photo of the Customer's Identity Document", "buttonText": "Document"},
    "IdentityBack": {"buttonHeader": "Photo of the back of the Customer's Identity Document", "buttonText": "Document"}
};

export default class RequestBankAccountComponent extends React.Component {
    constructor(props) {
        super(props);

        this.registrationHeaders = UserSessionService.retrieveRegisteringHeaders();
        this.schema = RegistrationCreationRequest.retrieveNewRegistrationValidationConfig();

        this.state = {
            currentStep: PERSONAL_DETAILS,
            currentStepIndex: 0,

            title: {"id": 0, "name": ""},
            ethnicity: {"id": 0, "name": ""},
            idIssueDate: "",
            unit: "",
            complexName: "",
            sourceOfFunds: {"id": 0, "name": ""},
            staysInComplex: {"id": 0, "name": ""},
            streetNumber: "",
            email: this.props.customer.emailAddress || "",

            touchedFields: {},
            inValidFields: {},
            validFields: {},

            requiredDocuments: [],
            selectedDocuments: [],
            uploadedDocuments: {},
            file: null,
            submitting: false,

            hasSmartIdCard: false
        };

        this.dropdownChange = this.dropdownChange.bind(this);
        this.renderDropdown = this.renderDropdown.bind(this);
        this.renderPersonalDetails = this.renderPersonalDetails.bind(this);
        this.hasBeenTouched = this.hasBeenTouched.bind(this);
        this.renderPermit = this.renderPermit.bind(this);
    }

    nextStep(currentStep, currentStepIndex) {
        let nextStepIndex = currentStepIndex + 1;
        let nextStep = STEPS[nextStepIndex];

        if (nextStep === CONTACT_DETAILS && this.props.customer.emailAddress) {
            nextStepIndex = nextStepIndex + 1;
            nextStep = STEPS[nextStepIndex];
        }

        if (nextStep === DOCUMENT_DETAILS && this.props.customer.idType !== SA_ID) {
            nextStepIndex = nextStepIndex + 1;
            nextStep = STEPS[nextStepIndex];
        }

        this.setState({
            currentStep: nextStep,
            currentStepIndex: nextStepIndex
        })
    }

    backStep(currentStep, currentStepIndex) {
        if (currentStepIndex !== 0) {
            let nextStepIndex = currentStepIndex - 1;
            let nextStep = STEPS[nextStepIndex];

            if (nextStep === CONTACT_DETAILS && this.props.customer.emailAddress) {
                nextStepIndex = nextStepIndex - 1;
                nextStep = STEPS[nextStepIndex];
            }

            if (nextStep === DOCUMENT_DETAILS && this.props.customer.idType !== SA_ID) {
                nextStepIndex = nextStepIndex - 1;
                nextStep = STEPS[nextStepIndex];
            }

            this.setState({
                currentStep: nextStep,
                currentStepIndex: nextStepIndex
            })
        }
    }

    dropdownChange = (event, field) => {

        let newEvent;
        if (event === null) {
            if (field === 'country') {
                newEvent = {"id": "", "name": ""}
            } else {
                newEvent = {"id": 0, "name": ""}
            }
        } else {
            newEvent = {...event};
        }

        this.setState({
            [field]: {
                id: newEvent.id,
                name: newEvent.name
            }
        }, () => this.validateInputField(field));
    };

    handleDateChange(field, value) {
        this.setState({
            [field]: value
        }, () => this.validateInputField(field))
    }

    handleChange = (event, field) => {

        this.setState({
            [event.target.id]: event.target.value
        }, () => {

            if (field === "idNumber") {
                if (this.state.idType.name === SA_ID) {
                    this.setState({
                        gender: this.extractGenderFromID(this.state.idNumber),
                        DOB: this.extractDOBFromID(this.state.idNumber)
                    });
                } else {
                    this.setState({
                        gender: {"id": 0, "name": ""},
                        DOB: ''
                    });
                }
            }

            this.validateInputField(field)
        });
    };

    validateInputField(field) {
        let self = this;
        let previousInvalidValidations = {...this.state.inValidFields};
        delete previousInvalidValidations[field];
        let previousValidValidations = {...this.state.validFields};
        previousValidValidations[field] = true;

        this.setState({
            inValidFields: previousInvalidValidations,
            validFields: previousValidValidations
        }, () => {

            let fieldValue = this.state[field].id === undefined ? this.state[field] : this.state[field].name;

            if (field === "idType" && fieldValue === SA_ID) {
                delete this.schema["idNumber"];
                this.schema["idNumber"] = RegistrationCreationRequest.retrieveSAIDValidationConfig()
                this.invalidateIdNumber();
            } else if (field === "idType" && fieldValue !== SA_ID) {
                delete this.schema["idNumber"];
                this.schema["idNumber"] = RegistrationCreationRequest.retrieveNonSAIDValidationConfig();
                this.invalidateIdNumber();
            } else if (field === "country" && this.state["idType"].name !== SA_ID) {
                this.schema["country"] = RegistrationCreationRequest.retrieveCountryValidationConfig();
            } else if (field === "email") {
                delete this.schema["email"];
                this.schema["email"] = RegistrationCreationRequest.retrieveEmailRequiredValidationConfig(true);
            } else if (field === "cardRequested" && fieldValue === "No") {
                delete this.schema["email"];
                this.schema["email"] = RegistrationCreationRequest.retrieveEmailRequiredValidationConfig(false);
                this.hasBeenTouched("email");
            } else if (field === "cardRequested" && fieldValue === "Yes" && this.state.phoneNumber !== "") {
                this.hasBeenTouched("email");
            }

            if (this.schema[field] !== undefined) {
                this.schema[field].validate({[field]: fieldValue}).catch(function (err) {

                    let previousInvalidValidations = {...self.state.inValidFields};
                    previousInvalidValidations[field] = err.message;
                    let previousValidValidations = {...self.state.validFields};
                    delete previousValidValidations[field];
                    self.setState({
                        inValidFields: previousInvalidValidations,
                        validFields: previousValidValidations
                    });
                })
            }
        });
    }

    isNextButtonValid(config) {
        let allFieldsComplete = true;

        config.forEach(field => {

            if (field === "title" && this.state.title.id === "") return;
            if (field === "ethnicity" && this.state.ethnicity.id === "") return;
            if (field === "sourceOfFunds" && this.state.sourceOfFunds.id === "") return;
            if (field === "complexName" && this.state.complexName !== "") return;
            if (field === "unit" && this.state.unit !== "") return;
            if (this.state.validFields[field] === undefined) {
                allFieldsComplete = false;
            }
        });

        if (this.state.currentStep === DOCUMENT_DETAILS) {
            if (this.state.hasSmartIdCard) {
                allFieldsComplete = this.doneSelectingDocument("Identity") && this.doneSelectingDocument("IdentityBack") && allFieldsComplete;
            }
        }
        if (this.state.currentStep === PERMIT_DETAILS) {
            allFieldsComplete = this.doneSelectingDocument("Permit") && allFieldsComplete;
        }

        return allFieldsComplete;
    }

    handleFinalSubmitClick() {
        this.handleUpload();
    }

    handleUpload() {

        let self = this;

        if(this.state.requiredDocuments.length > 0){
            Object.keys(this.state.selectedDocuments).forEach(selectedDocument => {

                let documentType = selectedDocument;

                let file = this.state.selectedDocuments[selectedDocument];

                let fileType = FileUtil.getExtensionOfFile(file.fileUpload.name);
                let mimeType = FileUtil.getMimeType(fileType);

                let s3Document = {
                    "file-type": fileType,
                    "registration-document-type": documentType
                };

                RegistrationDocumentsService.retrievePresignedUrl(s3Document).then(response => {
                    if (response.presignedUrl === undefined) {
                        ToastHelper.error("Failed to retrieve upload url.");
                        return;
                    }

                    const xhr = new XMLHttpRequest();
                    xhr.open('PUT', response.presignedUrl);
                    xhr.onreadystatechange = function () {
                        if (xhr.readyState === 4) {
                            if (xhr.status === 200) {
                                let uploadedDocument = {...self.state.uploadedDocuments};
                                uploadedDocument[documentType] = response;
                                self.setState({
                                    uploadedDocuments: uploadedDocument
                                }, () => self.doneUploadingDocument());
                            } else {
                                ToastHelper.error("Error while uploading image.");
                            }
                        }
                    };
                    xhr.overrideMimeType(mimeType);
                    xhr.setRequestHeader('Content-Type', mimeType);
                    xhr.send(file.fileUpload);
                });
            });
        } else {
            self.doneUploadingDocument()
        }

    }

    doneUploadingDocument() {

        let allUploaded = true;
        this.state.requiredDocuments.forEach(requiredDocument => {
            if (this.state.uploadedDocuments[requiredDocument.documentType] === undefined) {
                allUploaded = false;
            }
        });
        if (allUploaded) {
            this.submitRequest();
        } else {
            this.setState({
                loading: false
            })
        }
    }

    doneSelectingDocument(documentType) {
        let allSelected = true;
        if (this.state.selectedDocuments[documentType] === undefined) {
            allSelected = false;
        }

        return allSelected;
    }

    submitRequest() {

        let documents = [];

        for (let i = 0; i < this.state.requiredDocuments.length; i++) {

            let documentType = this.state.requiredDocuments[i].documentType;

            documents.push({
                "meta-data-id": this.state.uploadedDocuments[documentType].id,
                "document-type": documentType
            })
        }

        let request = {};
        request.title = this.state.title.id;
        request.ethnicity = this.state.ethnicity.id;
        request.idIssueDate = this.state.idIssueDate;
        request.unit = this.state.unit;
        request.complexName = this.state.complexName;
        request.sourceOfFunds = this.state.sourceOfFunds.id;
        request.streetNumber = this.state.streetNumber;
        request.documents = documents;
        request.email = this.state.email;

        RegistrationService.requestBankAccount(this.props.registrationId, request).then(response => {
            if (response.id) {
                ToastHelper.success("Bank Account Request Submitted Successfully")
                if (this.props.btnCancelClick) {
                    this.props.btnCancelClick();
                }
            } else {
                ToastHelper.formatError(response);
                if (this.props.btnCancelClick) {
                    this.props.btnCancelClick();
                }
            }
        });
    }

    hasBeenTouched(field) {
        let previousTouched = {...this.state.touchedFields};
        previousTouched[field] = true;
        this.setState({
                touchedFields: previousTouched
            }, () => this.validateInputField(field)
        )
    }

    toggleHasSmartIdCard() {
        this.setState({
            hasSmartIdCard: !this.state.hasSmartIdCard
        });
    }

    addDocumentToRequiredDocumentList(documentType) {

        let documentInList = false;

        for (let i = 0; i < this.state.requiredDocuments.length; i++) {
            if (this.state.requiredDocuments[i].documentType === documentType) {
                documentInList = true;
            }
        }

        if (documentInList === false) {
            let document = {
                "id": 0,
                "registeringChannelId": this.registrationHeaders["registering-channel-id"],
                "documentType": documentType
            };
            this.state.requiredDocuments.push(document)
        }
    }

    render() {

        if (this.state.submitting) {
            return <LoadingSpinnerComponent/>
        }

        let className = this.props.isMobile ? "mobile" : "browser";

        switch (this.state.currentStep) {
            case PERSONAL_DETAILS:
                return this.renderPersonalDetails(className);
            case CONTACT_DETAILS:
                return this.renderContactDetails(className);
            case ADDRESS_DETAILS:
                return this.renderAddressDetails(className);
            case DOCUMENT_DETAILS:
                return this.renderDocumentDetails(className);
            case PERMIT_DETAILS:
                return this.renderPermit(className)
            default :
                return <Fragment>Unknown Step</Fragment>
        }
    }

    //STEP 1
    renderPersonalDetails(className) {
        return <Fragment>
            <ViewHeaderComponent>Personal Details</ViewHeaderComponent>
            {this.renderDropdown(className, TITLES, "title", "Title", "user")}
            {this.renderDropdown(className, ETHNICITY, "ethnicity", "Ethnicity", "user")}
            {this.renderDropdown(className, SOURCE_OF_FUNDS, "sourceOfFunds", "Source of funds", "money")}
            {this.renderDatePicker(className, "ID Issue Date", "idIssueDate")}
            <hr/>
            {this.renderModalFooterBackButton(className)}
            {'   '}
            {
                <Fragment>
                    {this.renderModalFooterNextButton(PERSONAL_DETAILS_CONFIG)}
                </Fragment>
            }
        </Fragment>
    }

    //STEP 2
    renderContactDetails(className) {
        return <Fragment>
            <ViewHeaderComponent>Contact details</ViewHeaderComponent>
            {this.renderInput(className, "Email Address", "email")}
            <hr/>
            {this.renderModalFooterBackButton(className)}
            {'   '}
            {
                <Fragment>
                    {this.renderModalFooterNextButton(CONTACT_DETAILS_CONFIG)}
                </Fragment>
            }
        </Fragment>
    }

    //STEP 3
    renderAddressDetails(className) {
        return <Fragment>
            <ViewHeaderComponent>Address Details</ViewHeaderComponent>
            {this.renderInput(className, "Street Number", "streetNumber")}
            <Fragment>
                <p className={className }>Does the customer live in a complex?</p>
            </Fragment>
            {this.renderDropdown(className, COMPLEX_OPTIONS, "staysInComplex", "Select")}
            {this.state.staysInComplex.name === "Yes" ? this.renderInput(className, "Unit Number", "unit") : null}
            {this.state.staysInComplex.name === "Yes" ? this.renderInput(className, "Complex/Building Name", "complexName") : null}
            <hr/>
            {this.renderModalFooterBackButton(className)}
            {'   '}

            {
                this.state.staysInComplex.name === "Yes" ?
                    <Fragment>
                        {this.renderModalFooterNextButton(ADDRESS_DETAILS_CONFIG)}
                    </Fragment>
                    :
                    <Fragment>
                        {this.renderModalFooterNextButton(STAYS_IN_COMPLEX)}
                    </Fragment>
            }


        </Fragment>
    }

    //STEP 4
    renderDocumentDetails(className) {
        return <Fragment>
            {!this.props.isMobile ? <Fragment><h2 className={"browser_register_sub_heading"}>Documents</h2>
                    <br/>
                </Fragment>
                :
                <Fragment>

                </Fragment>
            }

            {
                this.props.customer.idType === SA_ID && <Fragment>
                    {this.renderTickBox(className)}
                </Fragment>
            }
            {
                this.state.hasSmartIdCard === true && <Fragment>
                    <br/>
                    {this.addDocumentToRequiredDocumentList("Identity")}
                    <S3DocumentUploadComponent
                        key={"Identity"}
                        documentType={"Identity"}
                        showButton={false}
                        buttonConfig={BUTTON_HEADERS["Identity"]}
                        className={className}
                        fileSelected={this.state.selectedDocuments["Identity"] !== undefined}
                        onFileSelected={file => {
                            if (file !== null) {
                                let docArr = {...this.state.selectedDocuments};
                                docArr["Identity"] = file;
                                this.setState({
                                    selectedDocuments: docArr
                                })
                            }
                        }}

                    />


                    <br/>
                    {this.addDocumentToRequiredDocumentList("IdentityBack")}

                    <S3DocumentUploadComponent
                        key={"IdentityBack"}
                        documentType={"IdentityBack"}
                        showButton={false}
                        buttonConfig={BUTTON_HEADERS["IdentityBack"]}
                        className={className}
                        fileSelected={this.state.selectedDocuments["IdentityBack"] !== undefined}
                        onFileSelected={file => {
                            if (file !== null) {
                                let docArr = {...this.state.selectedDocuments};
                                docArr["IdentityBack"] = file;
                                this.setState({
                                    selectedDocuments: docArr
                                })
                            }
                        }}
                    />
                </Fragment>

            }

            <hr/>
            {this.renderModalFooterBackButton(className)}
            {'   '}
            {
                <Fragment>
                    {this.renderModalFooterNextButton([])}
                </Fragment>
            }
        </Fragment>

    }

    //STEP 5
    renderPermit(className) {
        let addPermitToRequiredDocuments = this.props.customer.idType === FOREIGN_PASSPORT;
        if (addPermitToRequiredDocuments) {
            this.addDocumentToRequiredDocumentList("Permit")
        }
        return <Fragment>
            <ViewHeaderComponent>Permit</ViewHeaderComponent>
            <S3DocumentUploadComponent
                key={"Permit"}
                documentType={"Permit"}
                showButton={false}
                buttonConfig={BUTTON_HEADERS["Permit"]}
                className={className}
                fileSelected={this.state.selectedDocuments["Permit"] !== undefined}
                onFileSelected={file => {
                    if (file !== null) {
                        let docArr = {...this.state.selectedDocuments};
                        docArr["Permit"] = file;
                        this.setState({
                            selectedDocuments: docArr
                        })
                    }

                }}
            />

            <hr/>
            {this.renderModalFooterBackButton(className)}
            {'   '}
            {
                <Fragment>
                    {this.renderModalFooterNextButton([])}
                </Fragment>
            }
        </Fragment>
    }

    renderModalFooterBackButton(className) {
        return <Fragment>
            {this.state.currentStep !== PERSONAL_DETAILS ?
                <SFXButtonComponent onClick={() => this.backStep(this.state.currentStep, this.state.currentStepIndex)}>
                    Back
                </SFXButtonComponent>
                :
                <SFXButtonComponent onClick={this.props.btnCancelClick}>
                    Cancel
                </SFXButtonComponent>
            }
        </Fragment>
    }

    renderModalFooterNextButton(config) {

        let lastStep = PERMIT_DETAILS;

        if (this.props.customer.idType === ASYLUM_PAPER) {
            lastStep = ADDRESS_DETAILS
        } else if (this.props.customer.idType === SA_ID) {
            lastStep = DOCUMENT_DETAILS
        }

        return <Fragment>
            {this.state.currentStep === lastStep ?
                <Fragment>
                    {this.renderSubmitButton(config)}
                </Fragment>
                :
                <SFXButtonComponent onClick={() => this.nextStep(this.state.currentStep, this.state.currentStepIndex)}
                                    className={"btn btn-primary"}
                                    disabled={!this.isNextButtonValid(config)}
                >
                    Next
                </SFXButtonComponent>
            }
        </Fragment>
    }

    renderInput(className, text, field) {

        return <Row className={className + "_input_row_register"}>
            <div className={className + "_input_div_register"}>
                <Input value={this.state[field]} placeholder={text}
                       id={field}
                       onChange={(event) => this.handleChange(event, field)}
                       onBlur={() => this.hasBeenTouched(field)}
                />
                {
                    this.state.touchedFields[field] && this.state.inValidFields[field] && this.renderErrorMessage(className, field)
                }
            </div>
        </Row>
    }

    renderDropdown(className, dropdownOptions, field, text) {
        return <Row className={className + "_input_row_register"}>
            <div className={className + "_input_div_register"}>
                <DropdownComponent
                    value={this.state[field].id || ""}
                    options={dropdownOptions}
                    placeholder={text}
                    disableSearch={true}
                    firstTouch={() => this.hasBeenTouched(field)}
                    onChange={(selectedOption) => {
                        this.dropdownChange(selectedOption, field)
                    }}
                />
                {
                    this.state.touchedFields[field] && this.state.inValidFields[field] && this.renderErrorMessage(className, field)
                }
            </div>
        </Row>
    }

    renderDatePicker(className, text, field) {

        let dateType = "";
        if (field === "DOB") {
            dateType = "PAST";
        } else if (field === "idExpiryDate") {
            dateType = "ID_EXPIRY";
        } else if (field === "idIssueDate") {
            dateType = "PAST";
        }

        return <Row className={className + "_input_row_register"}>
            <div className={className + "_input_div_register"}>
                <DatePickerComponent
                    onChange={(value) => {
                        this.handleDateChange(field, value)
                    }}
                    firstTouch={() => this.hasBeenTouched(field)}
                    value={this.state[field]}
                    placeholder={text}
                    type={dateType}
                />
                {
                    this.state.touchedFields[field] && this.state.inValidFields[field] && this.renderErrorMessage(className, field)
                }
            </div>
        </Row>
    }

    renderErrorMessage(className, field) {
        return <h6 className={className + "_error_message_register"}>
            {this.state.inValidFields[field]}
        </h6>;
    }

    renderSubmitButton(config) {
        return <Fragment>
            <SFXButtonComponent onClick={() =>
                this.setState({
                    submitting: true,
                }, this.handleFinalSubmitClick)}
                                className={"btn btn-primary"}
                                disabled={!this.isNextButtonValid(config)}
            >
                Submit
            </SFXButtonComponent>

        </Fragment>
    }

    renderTickBox(className) {

        return <Fragment>

            <Row className={className + "_row"}>
                <Col>
                    <div style={{display: "flex", flex: "4"}}>
                        <div style={{width: "15%", marginBottom: "30px", textAlign: "right"}}>
                            <Input style={{transform: "scale(2.5)", flex: "1"}}
                                   onChange={() => this.toggleHasSmartIdCard()}
                                   type="checkbox"
                                   checked={this.state.hasSmartIdCard}
                            />
                        </div>
                        <div style={{textAlign: "left", flex: "3", margin: "auto", paddingLeft: "10px"}}>Do you have a
                            smart id card?
                        </div>
                    </div>
                </Col>
            </Row>

        </Fragment>
    }
}
